import { postTypeGQLFields, } from '../post-type/postType.fields.js';
import { spaceMemberGQLFields, } from '../space/spaceMember.fields.js';
import { actionPermissionGQLFields, } from './actionPermissions.fields.js';
const BASIC_SPACE_AUTH_MEMBER_PROPS_FIELDS = {};
const ALL_SPACE_AUTH_MEMBER_PROPS_FIELDS = {
    permissions: 'basic',
    availablePostTypes: 'basic',
};
export function spaceAuthMemberPropsGQLFields(fields) {
    if (fields === 'basic') {
        fields = BASIC_SPACE_AUTH_MEMBER_PROPS_FIELDS;
    }
    if (fields === 'all') {
        fields = ALL_SPACE_AUTH_MEMBER_PROPS_FIELDS;
    }
    return `
    context
    lastReadAt
    membershipStatus
    scopes
    unreadPostsCount
    ${fields.permissions
        ? `
      permissions {
        ${actionPermissionGQLFields(fields.permissions)}
      }
    `
        : ``}
    ${fields.availablePostTypes
        ? `
      availablePostTypes {
        ${postTypeGQLFields(fields.availablePostTypes)}
      }`
        : ''}
    ${fields.spaceMember
        ? `
      spaceMember {
        ${spaceMemberGQLFields(fields.spaceMember)}
      }`
        : ''}
  `;
}
//# sourceMappingURL=spaceAuthMemberProps.fields.js.map